import { makeStyles, MessageBar, MessageBarBody, MessageBarTitle } from "@fluentui/react-components";
import { useTranslation } from "react-i18next";
import { dolphinTokens } from "../../utils/Theme";

const useStyles = makeStyles({
    errorMessage: {
        marginBottom: "1rem",
        backgroundColor: dolphinTokens.colorTomatoRed20,

        "& svg": {
            color: dolphinTokens.colorTomatoRed,
        }
    },
    successMessage: {
        backgroundColor: dolphinTokens.colorMintGreen20,

        "& svg": {
            color: dolphinTokens.colorMintGreen,
        }
    },
});

const EnquiryFailedMessage = () => {
    const { t } = useTranslation(["contact", "general"]);
    const styles = useStyles();

    return (
        <MessageBar intent="error" className={styles.errorMessage} shape="rounded" layout="multiline">
            <MessageBarBody>
                <MessageBarTitle>
                    {t("error", { ns: "general" })}
                </MessageBarTitle>
                {t("form.errorMessage")}
            </MessageBarBody>
        </MessageBar>
    );
}

const EnquirySubmittedMessage = () => {
    const { t } = useTranslation("contact");

    return (
        <MessageBar intent="success" shape="rounded" layout="multiline">
            <MessageBarBody>
                {t("form.successMessage")}
            </MessageBarBody>
        </MessageBar>
    );
}

export { EnquiryFailedMessage, EnquirySubmittedMessage };